import React from 'react';

import StyledTooltip from '../../General/Tooltip/StyledTooltip';
import RibbonButtonSize from './RibbonButtonSize';
import type { IRibbonBtnConfig } from './RibbonConfig';

import styles from './RibbonMenuButton.module.scss';
import { Typography } from '@mui/material';
import { upperCaseBegin } from '../../../utils/stringUtils';
import { GlobalVariables } from '../../../pdf/GlobalVariables';

export default (props: IRibbonBtnConfig) => {
    if (!props.config) {
        console.error(`Missing props.config: ${JSON.stringify(props)}`);
        return <></>;
    }

    const textOnly: boolean = props.size === RibbonButtonSize.TextOnly;
    const iconOnly: boolean =
        props.size === RibbonButtonSize.LargeIcon ||
        props.size === RibbonButtonSize.SmallIcon ||
        props.size === RibbonButtonSize.DropDown;
    const isLargeIcon: boolean =
        props.size === RibbonButtonSize.LargeIcon ||
        props.size === RibbonButtonSize.LargeIconWithText ||
        props.size === RibbonButtonSize.DropDown;
    const buttonRef = React.useRef<HTMLButtonElement>(null);

    const cssClasses: string[] = [styles.button];

    if (props.className) {
        cssClasses.push(props.className);
    }

    if (isLargeIcon) {
        cssClasses.push(styles.buttonL);
    }

    if (props.config.HasHint()) {
        const tooltipTitle = (
            <>
                <Typography color="inherit">
                    {props.config.GetTitle()}
                    <span
                        style={{
                            fontSize: '12px',
                            fontWeight: 'bold',
                            float: 'right',
                            margin: '4px 0px 0px 10px',
                        }}
                    >
                        {props.config.GetShortcut()}
                    </span>
                </Typography>
                {props.config.GetHint()}
            </>
        );

        const button = (
            <button
                ref={buttonRef}
                key={`rbnMenuBtn-${props.config.Key}`}
                className={cssClasses.join(' ')}
                disabled={!props.config.Enabled}
                onClick={props.config.Callback}
                style={!props.config.Enabled ? { pointerEvents: 'none' } : {}}
            >
                {!textOnly && props.config.GetIcon()}
                {!iconOnly && props.config.GetTitle()}
            </button>
        );

        return (
            <StyledTooltip
                key={props.config.GetUniqueKey()}
                title={tooltipTitle}
                PopperProps={{
                    anchorEl: {
                        getBoundingClientRect: () => {
                            return new DOMRect(
                                buttonRef.current !== null
                                    ? buttonRef.current.getBoundingClientRect().x + 50
                                    : 0,
                                140,
                                0,
                                0,
                            );
                        },
                    },
                }}
            >
                {!props.config.Enabled ? <span>{button}</span> : button}
            </StyledTooltip>
        );
    }

    return (
        <button
            id={
                GlobalVariables.isForTestRun
                    ? `rbnMenuBtn${upperCaseBegin(props.config.Key)}`
                    : undefined
            }
            key={`rbnMenuBtn-${props.config.Key}`}
            className={cssClasses.join(' ')}
            disabled={!props.config.Enabled}
            onClick={props.config.Callback}
        >
            {!textOnly && props.config.GetIcon()}
            {!iconOnly && props.config.GetTitle()}
        </button>
    );
};
